import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginWithEmail, logout } from "@/auth/firebase";

const initialState = {
  data: undefined,
  loading: false,
  error: null,
};

export const loginUserWithCredentials = createAsyncThunk(
  "user/login",
  async ({ email, password }, { rejectWithValue }) =>
    await loginWithEmail(email, password).catch((newError) => rejectWithValue(newError.message)),
);

export const logoutUser = createAsyncThunk(
  "user/logout",
  async (_, { rejectWithValue }) => await logout().catch((newError) => rejectWithValue(newError?.message || newError)),
);

const authSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    clearUser(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUserWithCredentials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUserWithCredentials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state) => {
        state.data = null;
        state.loading = false;
        state.error = null;
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { setUser, clearUser } = authSlice.actions;

export default authSlice.reducer;
